import React from 'react'

const ConfirmContext = React.createContext([{}, function () {}])

export default ConfirmContext
